import { Container } from '../../../odie';
import { HatBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { SpineView, spineLoader } from '@play-co/timestep-spine';
import { playSpineAnimation } from 'src/lib/ui/utils/spine';

export const crateSpine = {
  loadMethod: spineLoader,
  url: getMatch2AssetPath('blocks/crate/animation/spine.crate'),
};

export class CrateBlockView extends Container {
  public spine?: SpineView;

  constructor(props: HatBlockProps) {
    super();
    blockPositionView(this, props);
    this.createSpine();
  }

  private async createSpine() {
    if (this.spine) return;
    await spineLoader(crateSpine.url);
    this.spine = new SpineView({
      superview: this.view,
      spinePath: crateSpine.url,
      scale: 0.65,
    });
    playSpineAnimation(this.spine, { animation: 'idle', loop: true });
  }

  public static assets() {
    return ['fx.crate/', crateSpine];
  }

  public async playBreakAnimation() {
    if (!this.spine) return;
    await playSpineAnimation(this.spine, { animation: 'explode', loop: false });
  }
}
